import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import NormalImg from '../common/Img';
import RequisitesImg from './req.png';

const Img = styled(NormalImg)`
  width: 100%;
  margin: 200px auto 30px auto;
  display: block;
`;

class RequisitesPage extends Component{
  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Link to="/participants"><Img src={RequisitesImg} alt="Requisites" /></Link>
        </div>
      </div>
    );
  }
}

export default RequisitesPage;



// WEBPACK FOOTER //
// ./src/components/requisites/RequisitesPage.js